
// import { useEffect, useState } from 'react';
// import { ErrorMessage, useField } from 'formik';
// import { Autocomplete, CircularProgress, TextField } from "@mui/material";




// export const AutocompleteConLoading = ({ label, options=[], bloqueo=false, handleFunction=null, loading, ...props }) => {


//     const [field, meta] = useField(props);
//     const hasError = meta.touched && meta.error;
//     const [selectedValue, setSelectedValue] = useState<any>(null); 


//     useEffect(() => {
//         setSelectedValue(props.value || null);
//     }, [props.value]);


    
//     const handleChange = (newValue) => {
//         const value = newValue ? newValue.id : null;
//         setSelectedValue(value);
//         field.onChange({ target: { name: props.name, value } });
//     }



//     const handleInputChange = (_, value) => {
//         if (handleFunction) {
//             handleFunction(value);
//         }
//     };



//     return (
//         <>
//             <Autocomplete
//                 disabled={bloqueo} 
//                 loading={loading}
//                 value={ options.find(valor => valor?.id == selectedValue) || null}
//                 options={ options }
//                 onChange={ (_, newValue) => handleChange(newValue)}
//                 onInputChange={ handleInputChange }
//                 renderInput={(params) => <TextField
//                     autoComplete="off"
//                     {...params} 
//                     label={ label }  
//                     error={ !!hasError }
//                     { ...field } 
//                     { ...props }
//                     InputProps={{ ...params.InputProps,
//                     endAdornment: (
//                         <>{loading 
//                         ?   <CircularProgress color="inherit" size={20} />
//                         :   null
//                         }
//                         {params.InputProps.endAdornment}
//                         </>
//                     ),
//             }}
//                 />}
//                 getOptionLabel={(option) => option.nombre }
//             />
//             <ErrorMessage className='error-message' name={ props.name } component="span" />
//         </>
//     )
// }





import { useState, useEffect } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";

export const AutocompleteConLoading = ({label, options = [], bloqueo = false, handleFunction = null, loading, name, value, onChange, ...props}) => {
    
    const [selectedValue, setSelectedValue] = useState(null);


    useEffect(() => {
        setSelectedValue(value || null);
    }, [value]);



    const handleChange = (newValue) => {
        const val = newValue ? newValue.id : null;
        setSelectedValue(val);
        if (onChange) {
        onChange({ target: { name, value: val } }); // emula evento input
        }
    };



    const handleInputChange = (_, val) => {
        if (handleFunction) {
        handleFunction(val);
        }
    };




    return (
        <Autocomplete
            disabled={bloqueo}
            loading={loading}
            value={options?.find((opt) => opt?.id == selectedValue) || null}
            options={options}
            onChange={(_, newValue) => handleChange(newValue)}
            onInputChange={handleInputChange}
            getOptionLabel={(option) => option.nombre || ""}
            renderInput={(params) => (
                <TextField
                {...params}
                autoComplete="off"
                label={label}
                {...props}
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                    <>
                        {loading ? (
                        <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                    </>
                    ),
                }}
                />
            )}
        />
    );
};

